
angular.module('LBACompenSafeSite.Filters', [])
    .filter('yesno', function () {
        return function (input) {
            return input ? 'Yes' : 'No';
        };
    })
    .filter('enterupdateby', function () {
        return function (input, dt) {
            var result = 'N/A';

            if (null != input) {
                if (null != dt) {
                    result = input + ' ' + formatDateMMDDYYYYHHMMRaw(dt);
                }
                else {
                    result = input;
                }
            }

            return result;
        };
    })
    .filter('andor', function () {
        return function (input) {
            return input ? 'AND' : 'OR';
        };
    })
    .filter('schedulePayFormat', function () {
        return function (input, payout) {
            var result = 'N/A';
            if (null != input) {
                switch (payout.toLowerCase()) {
                    case 'bps':
                        result = formatDecimal4Raw(input);
                        break;
                    case 'flat':
                    case 'flatflat':
                        result = formatCurrency2DecimalRaw(input);
                        break;
                    default:
                        result = input;
                        break;
                }
            }

            return result;
        };
    })
    .filter('containedInArray', function () {
        return function (input, array) {
            var filtered = [];

            angular.forEach(input, function (obj) {
                if (array.indexOf(obj) > -1) {
                    filtered.push(obj);
                }
            });

            return filtered;
        };
    })
    .filter('formatDateMMDDYY', function () {
        //todo: update to use builtin angular date filter
        return function (item) {
            return formatDateMMDDYYRaw(item);
        };
    })
    .filter('formatDateMMDDYYYYHHMM', function () {
        return function (item) {
            return formatDateMMDDYYYYHHMM(item);
        };
    })
    .filter('formatDayOfWeekToText', function () {
        return function (input) {
            if (input == null) {
                return '';
            }
            if (input == 1) {
                return 'Sunday';
            }
            if (input == 2) {
                return 'Monday';
            }
            if (input == 3) {
                return 'Tuesday';
            }
            if (input == 4) {
                return 'Wednesday';
            }
            if (input == 5) {
                return 'Thursday';
            }
            if (input == 6) {
                return 'Friday';
            }
            if (input == 7) {
                return 'Saturday';
            }
        };
    })
    .filter('formatHourOfDayDisplay', function () {
        //Note: this filter is intended for fields where just the hour value is sent
        return function (input) {
            var post = '';
            var hour = '';

            if (input == null) {
                return null;
            }

            if (input < 12) {
                post = ':00 A.M.';
                hour = input;
            }

            if (input == 12) {
                post = ':00 P.M.';
                hour = input;
            }

            if (input > 12) {
                post = ':00 P.M.';
                hour = input - 12;
            }

            return hour + post;
        };
    })
    .filter('nafilter', function () {
        return function (input) {
            var result = 'N/A';

            if (null != input) {
                result = input;
            }

            return result;
        };
    })
    .filter('nullFilter', function () {
        return function (input, replaceText) {
            var result = replaceText;

            if (null != input) {
                result = input;
            }

            return result;
        };
    })
    .filter('currencynodecimal', ['$filter', function (filter) {
        var currencyFilter = filter('currency');
        return function (amount) {
            if (amount === null || amount === undefined) {
                return '-';
            }
            var value = currencyFilter(amount);
            var sep = value.indexOf('.');
            if (amount >= 0) {
                return value.substring(0, sep);
            }
            return value.substring(0, sep) + ')';
        };
    }])
    .filter('formatCurrency', function () {
        return function (amount) {
            return formatCurrency2DecimalRaw(amount);
        };
    })
    .filter('assignedfilter', function () {
        return function (arr, state) {
            var filtered = [];

            angular.forEach(arr, function (obj) {
                if (obj.assigned == state || (state == false && obj.assigned == null)) {
                    filtered.push(obj);
                }
            });

            return filtered;
        };
    })
    .filter('selectedfilter', function () {
        return function (arr, state) {
            var filtered = [];

            angular.forEach(arr, function (obj) {
                if (obj.selected == state || (state == false && obj.selected == null)) {
                    filtered.push(obj);
                }
            });

            return filtered;
        };
    })
    .filter('activefilter', function () {
        return function (arr, state, prop) {
            var filtered = [];

            if (state == 2) {
                filtered = arr;
            }
            else {
                angular.forEach(arr, function (obj) {
                    if (obj[prop] == state) {
                        filtered.push(obj);
                    }
                });
            }

            return filtered;
        };
    })
    .filter('phone', function () {
        return function (input) {
            if (!input) { return ''; }

            var value = input.toString().trim().replace(/^\+/, '');

            if (value.match(/[^0-9]/)) {
                return input;
            }

            var country, area, second, third;

            if (value.length == 10) {
                area = value.slice(0, 3);
                second = value.slice(3, 6);
                third = value.slice(6);
                return ("(" + area + ") " + second + "-" + third).trim();
            }
            else if (value.length == 11) {
                country = value.slice(0, 1);
                area = value.slice(1, 4);
                second = value.slice(4, 7);
                third = value.slice(7);
                return (country + "-" + area + "-" + second + "-" + third).trim();
            }
            else {
                return input;
            }
        };
    })
    .filter('empFilter', [function () {
        return function (emps, tlos) {
            var result = [];
            var found;
            angular.forEach(emps, function (emp, index) {
                found = false;
                angular.forEach(tlos, function (tlo, i) {
                    if (emp.EmpID == tlo.EmpID_TLO && tlo.Active) {
                        found = true;
                    }
                });
                if (!found) {
                    result.push(emp);
                }
            });
            return result;
        };
    }])
    .filter('resolveUrl', function () {
        return function (input) {
            return ResolveUrl(input);
        };
    })
    .filter('formatbps', function () {
        return function (input) {
            var result = '';
            if (null != input && input > 0) {
                result = formatDecimal3Raw(input) + ' bps';
            }
            return result;
        };
    })
    .filter('formatbpsonly', function () {
        return function (input) {
            var result = '';
            if (null != input) {
                result = formatDecimal3Raw(input);
            }
            return result;
        };
    })
    .filter('format3decimal', function () {
        return function (input) {
            var result = '';
            if (null != input) {
                result = formatDecimal3Raw(input);
            }
            return result;
        };
    })
    .filter('lockedpayperiods', function () {
        return function (periods, includeLocked) {
            var result = [];
            if (includeLocked) {
                result = periods;
            }
            else {
                for (var i = 0; i < periods.length; i++) {
                    if (periods[i].LockDown == null) {
                        result.push(periods[i]);
                    }
                }
            }
            return result;
        };
    })
    .filter('externallink', function () {
        return function (input) {
            var result = input;
            if (IsNullOrUndefined(input) === false) {
                if (input.toUpperCase().indexOf("HTTP://") < 0 && input.toUpperCase().indexOf("HTTPS://") < 0) {
                    result = "http://" + input;
                }
            }
            return result;
        };
    })
    .filter('occupancytype', function () {
        return function (input) {
            var result = '';

            switch (input.toLowerCase()) {
                case 'i':
                    result = 'Investment Property';
                    break;
                case 'o':
                    result = 'Owner Occupied';
                    break;
                case 's':
                    result = 'Second Home';
                    break;
                default:
                    result = '';
            }

            return result;
        };
    })
    .filter('momentFilter', function () {
        return function (input, replaceText) {
            var result = input;

            if (input instanceof Date && !isNaN(input)) {
                var tmpTime = input.getTime();
                var dt = new Date(new Date(tmpTime).getTime());
                result = moment.utc(dt).format("MM/DD/YYYY");
            }

            return result;
        };
    })
    .filter('momentWithTimeFilter', function () {
        return function (input, replaceText) {
            var result = input;
            if (input instanceof Date && !isNaN(input)) {
                var tmpTime = input.getTime();
                var dt = new Date(new Date(tmpTime).getTime());
                result = moment.utc(dt).format("MM/DD/YYYY hh:mm A");
            }

            return result;
        };
    })

    .filter('momentWithTimeFilterFromString', function () {
        return function (input, replaceText) {
            var result = input;
            if (!input) {
                return result;
            }
            input = new Date(input);
            if (input instanceof Date && !isNaN(input)) {
                var tmpTime = input.getTime();
                var dt = new Date(new Date(tmpTime).getTime());
                result = moment.utc(dt).format("MM/DD/YYYY hh:mm A");
            }

            return result;
        };
    })

    .filter('formatRawCurrency', function () {
        return function (input) {
            var result = '';
            if (null != input) {
                result = formatCurrencyRaw(input);
            }
            return result;
        };
    })

    .filter('formatCsvString', function () {
        return function (input, dt) {
            if (input == null || input == '' || !input.includes(',')) {
                return input || '';
            }

            let splitInput = input.split(',').map(x => x.trim());

            return splitInput.join(', ');
        };
    });
;
